import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function Time({
  className,
  _type,
  type,
  strict,
  onChange,
  uppercase,
  disableAM,
  disablePM,
  ...props
}) {
  function onInput(e) {
    let value = e.target.value;

    if (uppercase) {
      value = value.toUpperCase();
    }

    // Enforce time restrictions
    if (value && (disableAM || disablePM)) {
      const [hours, minutes] = value.split(":").map(Number);

      if (disableAM && hours < 12) {
        // If AM is disabled and time is before noon, set to 12:00
        value = `12:${minutes.toString().padStart(2, "0")}`;
        e.target.value = value;
      } else if (disablePM && hours >= 12) {
        // If PM is disabled and time is noon or after, set to 11:59
        value = `11:59`;
        e.target.value = value;
      }
    }

    onChange(value);
  }

  // Set min/max based on disableAM or disablePM props
  const minTime = disableAM ? "12:00" : "00:00";
  const maxTime = disablePM ? "11:59" : "23:59";

  return (
    <div>
      <input
        className={classNames("form-control", className)}
        style={{ height: "2.5rem" }}
        onInput={onInput}
        type="time"
        min={minTime}
        max={maxTime}
        {...props}
      />
      {(disableAM || disablePM) && (
        <small
          style={{ color: "#6c757d", marginTop: "0.25rem", display: "block" }}
        >
          {disableAM && "Only PM times allowed"}
          {disablePM && "Only AM times allowed"}
        </small>
      )}
    </div>
  );
}
Time.defaultProps = defaultProps;
export default Time;
